import nacl from "tweetnacl";
import { encode as b64 } from "@stablelib/base64";
import { decode }  from "@stablelib/base64";

let _publicKey = undefined;
let _privateKey = undefined;

function generateKeyPair() {
    const { publicKey, secretKey } = nacl.box.keyPair(); // Uint8Array(32) each
    const pub  = b64(publicKey);
    const priv = b64(secretKey);
    return {
        "publicKey": pub,
        "privateKey": priv,
    }
}

function getPublicKey() {
    if (_publicKey) {
        return _publicKey;
    }
    const keys = generateKeyPair();
    _publicKey = keys.publicKey;
    _privateKey = keys.privateKey;
    return _publicKey;
}

function getPrivateKey() {
    if (_privateKey) {
        return _privateKey;
    }
    const keys = generateKeyPair();
    _publicKey = keys.publicKey;
    _privateKey = keys.privateKey;
    return _privateKey;
}

export function decryptMessage(envelopeB64: string) {
    // -- decode everything ----------------------------------------------------
    const blob      = decode(envelopeB64);           // ephemPub | nonce | cipher
    const myPrivRaw = decode(getPrivateKey());

    if (blob.length < 32 + 24 + 16) {                // at minimum needs MAC
        throw new Error("envelope too short");
    }
    if (myPrivRaw.length !== 32) {
        throw new Error("private key must be 32 bytes");
    }

    // -- split into its three parts ------------------------------------------
    const ephemPub  = blob.subarray(0, 32);          // 0‥31
    const nonce     = blob.subarray(32, 56);         // 32‥55  (24 bytes)
    const cipher    = blob.subarray(56);             // rest

    // -- nacl.box.open returns null on failure -------------------------------
    const plain = nacl.box.open(cipher, nonce,
        ephemPub,
        myPrivRaw);
    if (!plain) throw new Error("decryption failed (bad key or tampered data)");

    //  convert to string
    const plainText = new TextDecoder().decode(plain);

    return plainText
}

export { getPublicKey, getPrivateKey };